const translations = {
  "en": {
    "Get started": "Get started",
    "Membership & perks arriving in minutes.": "Membership & perks arriving in minutes.",
    "Payment Successful": "Payment Successful"
  },
  "zh-tw": {
    "Get started": "開始使用",
    "Membership & perks arriving in minutes.": "會員資格與優惠將在數分鐘內開通。",
    "Payment Successful": "付款成功"
  }
};

export default translations;
